import {useTranslation} from "react-i18next";
import {PageTemplate} from "../../../shared/layout/PageTemplate";
import {IrrelevanceList} from "./components/IrrelevanceList";

export const Irrelevance = () => {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('side_bar.crud')}`} title={`${t('side_bar.irrelevance')}`}
                         content={<IrrelevanceList/>}/>
}